/**
 * User
 */
import Config from './Config';
import Util from './Util';
import GameInfo from './GameInfo';

const User: any = {
	isCheckNotExistGameAccount: () => {
		if ( Config.checkWriteNotExistGameAccount && ( !GameInfo.getGameName() || !GameInfo.getGameServerId() ) ) {
			return true;
		}

		return false;
	},

	setUser: ( articleList: any, param: any ) => {
		const usr: any = {};
		const originList = articleList;

		// My API has article object
		if ( !articleList.articleId ) {
			articleList = articleList.article;
		}

		usr._writer = Util.setDefaultByEmptyString( articleList.writer );
		usr._adminUser = Util.setDefaultByEmptyString( usr._writer.adminUser );
		usr._gameUser = Util.setDefaultByEmptyString( usr._writer.gameUser );
		usr._loginUser = Util.setDefaultByEmptyString( usr._writer.loginUser );
		usr.categoryName = ( originList.board && originList.board.boardName ) ?
			originList.board.boardName : articleList.category.categoryName;

		usr.writerInfo = usr._loginUser.name;
		usr._server = '';
		usr._postDate = articleList.postDate;

		usr._url = ( Config.useAPIListUrl && articleList.url ) ?
			`${articleList.url}${param}` :
			`${Config.viewPage}?articleId=${articleList.articleId}${param}`;

		// user custom url
		if ( Config.prefixPath ) {
			usr._url = `${Config.prefixPath}/board/${Config.board}/${Config.viewPage}?articleId=${articleList.articleId}${param}`;
		}

		if ( !isNaN( usr._postDate ) ) {
			usr._postDate = new Date( usr._postDate );
			usr._postDate = Util.toISOString( usr._postDate );
		}

		// @TODO List
		usr._gameCharacterId = Util.setDefaultByEmptyString( usr._gameUser.gameCharacterId );
		usr._gameCharName = Util.setDefaultByEmptyString( usr._gameUser.gameCharacterName );
		usr._gameServerId = Util.setDefaultByEmptyString( usr._gameUser.gameServerId );
		usr._loginName = Util.setDefaultByEmptyString( usr._loginUser.name );
		usr.isMyArticle = Config.guid && ( Config.guid === usr._loginUser.uid );

		if ( !usr._loginUser.uid && usr._gameUser ) {
			usr.isMyArticle = GameInfo.isEqualGameUser( usr._gameUser.gameCharacterName, usr._gameUser.gameServerId );
		}

		if ( !usr.isMyArticle && usr._loginUser.name ) {
			usr.isMyArticle = GameInfo.isEqualLoginName( usr._loginUser.name, usr._gameUser.gameServerId );
		}

		if ( Config.isUserInfoWithServer && Config.serverName && usr._gameUser && usr._gameUser.gameServerId ) {
		  usr._server = `<span class="server">${ Util.setDefaultByEmptyString( Config.serverName[ usr._gameUser.gameServerId ] ) }</span>`;
		}

		if ( !Config.isBnsApp ) {
			const userName = usr._loginUser.name || usr._gameUser.gameCharacterName || '';
			usr.writerInfo = ( !Config.isMyProfile || usr._adminUser ) ?
				`${ userName }` :
				`<a href="${GameInfo.userProfile( usr._loginUser.uid, Config.guid,
					usr._gameUser.gameCharacterName, usr._gameUser.gameServerId )}">${userName}</a>`;
		}

		// character + server
		if ( Config.writerInfo ) {
			usr._writerContents = articleList[ Config.writerInfo ].contents;
			usr.writerInfo = ( usr._writerContents ) ? '글: ' + usr._writerContents.writing : usr._writer.loginusr.name;
			usr.writerInfo = ( usr._writerContents && usr._writerContents.picture ) ?
				`${usr.writerInfo} / 그림: ${usr._writerContents.picture}` : usr.writerInfo;
            usr.writerInfo = ( usr._writerContents && usr._writerContents.illustrator ) ?
                `${usr.writerInfo} / 일러스트: ${usr._writerContents.illustrator}` : usr.writerInfo;

		} else if ( !Config.isBnsApp && usr._gameUser && usr._gameUser.gameCharacterName ) {
			usr.writerInfo = ( Config.isMyProfile ) ?
				`<a href="${GameInfo.gameUserProfile(usr._gameUser.gameUserUid, usr._loginUser.uid,
					Config.guid, usr._gameUser.gameCharacterName, usr._gameUser.gameServerId,
					usr._gameUser.gameCharacterId )}">${usr._gameUser.gameCharacterName}</a>` :
				`${usr._gameUser.gameCharacterName}`;
		}

		usr.thumbnailUrl = articleList.thumbnailUrl;
		usr.title = articleList.title;
		usr.hasVote = articleList.hasVote;
		usr.hasThumbnail = articleList.hasThumbnail;
		usr.articleId = articleList.articleId;
		usr.goodCount = articleList.goodCount;
		usr.commentCount = articleList.commentCount;
		usr.hitCount = articleList.hitCount;
		usr.summary = articleList.summary;
		usr.searchSummary = articleList.searchSummary;

		return usr;
	},
};

export default User;
